import Vue from 'vue';
export default Vue.extend({
    name: 'apiKeysIPSListItem',
    props: {
        name: {
            type: String,
            required: true
        },
        ip: {
            type: String,
            required: true
        },
        isEditing: {
            type: Boolean,
            required: true
        },
        copied: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            form: {
                valid: false,
                fields: {
                    name: {
                        value: '',
                        rules: [
                            (v) => v.length > 0 || this.$t('apiKeysPage.errors.required')
                        ]
                    },
                    ip: {
                        value: '',
                        rules: [
                            (v) => v.length > 0 || this.$t('apiKeysPage.errors.required'),
                            (v) => /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(v) || this.$t('apiKeysPage.errors.ipIncorrect')
                        ]
                    }
                }
            }
        };
    }
});
